import React from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

export default function WishlistTab({ loading, wishlist }) {
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center h-48">
                <ArrowPathIcon className="h-7 w-7 text-gray-950 animate-spin" />
                <p className="text-xs text-gray-500 mt-2.5 font-bold uppercase tracking-wider">Fetching Wishlist...</p>
            </div>
        );
    }

    if (!Array.isArray(wishlist) || wishlist.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-48 text-gray-400">
                <p className="text-sm font-semibold uppercase tracking-wider">No Wishlist Items Found</p>
            </div>
        );
    }

    return (
        <div className="space-y-4 w-full">
            <div className="flex items-center justify-between border-b border-gray-150 pb-2">
                <h3 className="text-sm font-semibold text-gray-900 uppercase">
                    Wishlist (Total: {wishlist.length})
                </h3>
            </div>

            <div className="space-y-4">
                {wishlist.map((item, idx) => {
                    const productId = item.product_id || "N/A";
                    const bookName = item.name || "Unknown Title";
                    const coverImg = item.image || "https://via.placeholder.com/80x120?text=No+Cover";
                    const price = item.price || item.credits || 0;
                    const stockStatus = item.stock_status || "N/A";
                    const permalink = item.permalink || "#";
                    const isAvailable = !!item.in_stock || stockStatus.toLowerCase() === "instock";

                    return (
                        <div key={productId + "-" + idx} className="relative flex flex-col sm:flex-row gap-4 p-4 border border-gray-200 bg-white rounded-lg hover:shadow-md transition-all duration-200 w-full sm:items-center justify-between">
                            <div className="flex gap-4 min-w-0 flex-grow">
                                <img
                                    src={coverImg}
                                    alt={bookName}
                                    className="w-[80px] h-[120px] object-cover rounded border border-gray-100 flex-shrink-0"
                                    onError={(e) => {
                                        e.target.src = "https://via.placeholder.com/80x120?text=No+Cover";
                                    }}
                                />

                                <div className="flex flex-col justify-between flex-grow min-w-0 pr-6">
                                    <div>
                                        <a
                                            href={permalink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="font-semibold text-sm text-gray-955 hover:underline block leading-snug"
                                            title="View Product Page"
                                        >
                                            {bookName}
                                        </a>
                                        <p className="text-[11px] text-gray-400 mt-1">
                                            Product ID: <span className="font-normal text-gray-700">{productId}</span>
                                        </p>
                                    </div>

                                    <div className="mt-3 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs border-t border-gray-150 pt-3 text-gray-600">
                                        <div className="flex items-center">
                                            <span className="font-medium text-gray-500 mr-1.5">Credits:</span>
                                            <span className="font-bold text-blue-600">{price}</span>
                                        </div>
                                        <div className="flex items-center">
                                            <span className="font-medium text-gray-500 mr-1.5">Availability:</span>
                                            <span className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide border ${isAvailable
                                                ? "bg-green-50 text-green-700 border-green-200"
                                                : "bg-red-50 text-red-700 border-red-200"
                                                }`}>
                                                {isAvailable ? "Available" : "Out of Stock"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="flex-shrink-0 flex items-center w-full sm:w-auto mt-3 sm:mt-0 sm:pr-2">
                                <a
                                    href={permalink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-full sm:w-auto inline-flex items-center justify-center px-4 py-2 border border-gray-900 rounded-md text-xs font-semibold text-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-200"
                                >
                                    Open Product
                                </a>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
